export default __webpack_public_path__ + "static/media/buyer_benefits_1.1d4f5414.svg";